module.exports = __webpack_public_path__ + "img/EMT-CRC_10X_WTA.def8ee48.png";